import { api } from '@/core/lib/api-client';
import { CreateSpreadsheetDto, IMailingIntegration, ResponseType } from '@link-in-bio/domain';

export const createSpreadsheet = (
  createSpreadsheetDto: CreateSpreadsheetDto,
): Promise<ResponseType<IMailingIntegration>> => {
  return api.post('/google-spreadsheet/create-spreadsheet', createSpreadsheetDto);
};
